var MONSTER_SIZES = [
	{ text: "Tiny", value: "Tiny" },
	{ text: "Small", value: "Small" },
	{ text: "Medium", value: "Medium" },
	{ text: "Large", value: "Large" },
	{ text: "Huge", value: "Huge" },
	{ text: "Gargantuan", value: "Gargantuan" },
];

export { MONSTER_SIZES };
